(function() {
  if (window.__vivienneConsentBanner) return;
  window.__vivienneConsentBanner = true;

  function privacyApi() {
    return window.Shopify && window.Shopify.customerPrivacy;
  }

  function shouldShow(api) {
    try {
      if (api && typeof api.shouldShowBanner === 'function') return api.shouldShowBanner();
    } catch (error) {}
    return false;
  }

  function submitConsent(accepted) {
    var api = privacyApi();
    var consent = {
      analytics: accepted,
      marketing: accepted,
      preferences: accepted
    };
    function close() {
      var root = document.querySelector('[data-vivienne-consent]');
      if (root) root.classList.remove('is-visible');
    }
    if (api && typeof api.setTrackingConsent === 'function') {
      api.setTrackingConsent(consent, close);
    } else {
      close();
    }
  }

  function build() {
    var api = privacyApi();
    if (!shouldShow(api) || document.querySelector('[data-vivienne-consent]')) return;
    var root = document.createElement('div');
    root.className = 'vivienne-consent is-visible';
    root.setAttribute('data-vivienne-consent', '');
    root.innerHTML = '<div class="vivienne-consent__panel" role="dialog" aria-live="polite" aria-label="Préférences de confidentialité"><div><strong class="vivienne-consent__brand">Maison Vivienne & Fille</strong><p class="vivienne-consent__text">Nous utilisons des cookies pour améliorer votre expérience, mesurer notre audience et personnaliser nos contenus.</p></div><div class="vivienne-consent__actions"><button type="button" class="vivienne-consent__button vivienne-consent__button--secondary" data-vivienne-consent-decline>Refuser</button><button type="button" class="vivienne-consent__button" data-vivienne-consent-accept>Accepter</button></div></div>';
    root.addEventListener('click', function(event) {
      if (event.target.closest('[data-vivienne-consent-accept]')) submitConsent(true);
      if (event.target.closest('[data-vivienne-consent-decline]')) submitConsent(false);
    });
    document.body.appendChild(root);
  }

  function boot(attempt) {
    if (privacyApi() || attempt > 20) {
      build();
      return;
    }
    setTimeout(function() { boot(attempt + 1); }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { boot(0); });
  } else {
    boot(0);
  }
})();
